import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "hidden"]

  format() {
    const input = this.displayTarget
    const oldValue = input.value
    const cursorPos = input.selectionStart

    // Count digits before cursor in old value
    let digitsBefore = 0
    for (let i = 0; i < cursorPos; i++) {
      if (/\d/.test(oldValue[i])) digitsBefore++
    }

    // Extract and cap digits
    const raw = oldValue.replace(/\D/g, "").slice(0, 10)
    const formatted = this.applyMask(raw)

    // Update fields
    input.value = formatted
    this.hiddenTarget.value = raw

    // Restore cursor after the same number of digits
    let newPos = 0
    let counted = 0
    for (let i = 0; i < formatted.length; i++) {
      newPos = i + 1
      if (/\d/.test(formatted[i])) {
        counted++
        if (counted >= digitsBefore) break
      }
    }
    if (digitsBefore === 0) newPos = 0
    input.setSelectionRange(newPos, newPos)
  }

  applyMask(digits) {
    if (digits.length === 0) return ""
    if (digits.length <= 3) return `(${digits}`
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  }
}
